import React from "react";
import { Row, Col } from "antd";
import { CasesByPhaseChart, CasesByClaimOutcomeAtInstitutionChart, CasesByClaimOutcomeAtFWDChart } from "./charts";
import { keepOnlyPTABQueryStrings } from "../../../../helpers/url";

const CaseTabStatusPhase = props => {
  const q = keepOnlyPTABQueryStrings(props.location.query);
  return (
    <div>
      <Row>
        <Col span={24} style={{ overflowX: "scroll" }}>
          <CasesByPhaseChart query={q} height={500} style={{ minWidth: 600 }} />
        </Col>
      </Row>
      <Row>
        <Col span={24} xl={12}>
          <CasesByClaimOutcomeAtInstitutionChart query={q} height={500} />
        </Col>
        <Col span={24} xl={12}>
          <CasesByClaimOutcomeAtFWDChart query={q} height={500} />
        </Col>
      </Row>
    </div>
  );
};

export default CaseTabStatusPhase;
